import { useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Building2, Loader2, MailCheck, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim() });
    } catch {}
    setSent(true);
    setSubmitting(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6" data-testid="forgot-password-page">
      <div className="w-full max-w-md space-y-7">
        <div className="flex items-center gap-3">
          <div className="h-10 w-10 rounded-lg bg-[#0F2942] flex items-center justify-center text-white"><Building2 className="h-5 w-5" /></div>
          <span className="font-display text-xl font-bold tracking-tight text-slate-900">EstatePulse</span>
        </div>
        {sent ? (
          <div className="rounded-xl border border-slate-200 bg-white p-6 text-center space-y-3" data-testid="forgot-confirmation">
            <MailCheck className="h-10 w-10 text-emerald-600 mx-auto" />
            <h2 className="font-display text-xl font-bold text-slate-900">Check your email</h2>
            <p className="text-sm text-slate-500">If that email is registered, a password reset link has been sent. The link expires in 1 hour.</p>
            <Link to="/" className="inline-flex items-center gap-1.5 text-sm text-[#0F2942] font-medium hover:underline"><ArrowLeft className="h-4 w-4" /> Back to sign in</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-6">
            <div className="space-y-2">
              <h2 className="font-display text-2xl font-bold tracking-tight text-slate-900">Reset your password</h2>
              <p className="text-sm text-slate-500">Enter your account email and we'll send you a reset link.</p>
            </div>
            <div className="space-y-1.5">
              <Label className="text-xs font-medium text-slate-600">Email</Label>
              <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="h-11" data-testid="forgot-email-input" />
            </div>
            <Button type="submit" disabled={submitting} className="w-full h-11 bg-[#0F2942] gap-2" data-testid="forgot-submit-button">
              {submitting && <Loader2 className="h-4 w-4 animate-spin" />} Send reset link
            </Button>
            <Link to="/" className="inline-flex items-center gap-1.5 text-sm text-slate-500 hover:text-slate-800"><ArrowLeft className="h-4 w-4" /> Back to sign in</Link>
          </form>
        )}
      </div>
    </div>
  );
}
